import axios from "axios";

interface DownloadPdfParams {
  id: number;
  fileName: string;
}

export const downloadReportPdf = async ({ id, fileName }: DownloadPdfParams) => {
  if (!id) return;

  try {
    // OpenAPI.tsの適用外のため、以下のようにAPIのURLを設定
    const baseUrl = import.meta.env.VITE_BASE_URL || "http://localhost:8081";
    const response = await axios.get(
      `${baseUrl}/admin/report/${id}/pdf-download`,
      {
        responseType: "blob",
        // ログインの Cookie で認証する（生成コードの API と同じ。OpenAPI.ts の WITH_CREDENTIALS）
        withCredentials: true,
      }
    );

    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${fileName}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    return true;
  } catch (error) {
    console.error("Failed to download quotation:", error);
    throw new Error("報告書のダウンロードに失敗しました");
  }
};


export const downloadReportDefaultPdf = async ({ id, fileName }: DownloadPdfParams) => {
  if (!id) return;

  try {
    // OpenAPI.tsの適用外のため、以下のようにAPIのURLを設定
    const baseUrl = import.meta.env.VITE_BASE_URL || "http://localhost:8081";
    const response = await axios.get(
      `${baseUrl}/admin/report/${id}/pdf-download-s3`,
      {
        responseType: "blob",
        // ログインの Cookie で認証する（生成コードの API と同じ。OpenAPI.ts の WITH_CREDENTIALS）
        withCredentials: true,
      }
    );

    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${fileName}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    return true;
  } catch (error) {
    console.error("Failed to download quotation:", error);
    throw new Error("報告書のダウンロードに失敗しました");
  }
};


export const downloadOrderPdf = async ({ id, fileName }: DownloadPdfParams) => {
  if (!id) return;

  try {
    // OpenAPI.tsの適用外のため、以下のようにAPIのURLを設定
    const baseUrl = import.meta.env.VITE_BASE_URL || "http://localhost:8081";
    const response = await axios.get(
      `${baseUrl}/admin/order/${id}/pdf-download`,
      {
        responseType: "blob",
        // ログインの Cookie で認証する（生成コードの API と同じ。OpenAPI.ts の WITH_CREDENTIALS）
        withCredentials: true,
      }
    );

    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${fileName}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    return true;
  } catch (error) {
    console.error("Failed to download quotation:", error);
    throw new Error("受注書のダウンロードに失敗しました");
  }
};

export const downloadOrderDefaultPdf = async ({ id, fileName }: DownloadPdfParams) => {
  if (!id) return;

  try {
    // OpenAPI.tsの適用外のため、以下のようにAPIのURLを設定
    const baseUrl = import.meta.env.VITE_BASE_URL || "http://localhost:8081";
    const response = await axios.get(
      `${baseUrl}/admin/order/${id}/pdf-download-s3`,
      {
        responseType: "blob",
        // ログインの Cookie で認証する（生成コードの API と同じ。OpenAPI.ts の WITH_CREDENTIALS）
        withCredentials: true,
      }
    );

    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${fileName}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    return true;
  } catch (error) {
    console.error("Failed to download quotation:", error);
    throw new Error("受注書のダウンロードに失敗しました");
  }
};